<template>
  <div class="pagination-block">
    <div class="pagination-tool mr-20  hide-on-pad" :class="{ disabled:listLoading || total<=pageSize || pages==1 }" @click="goPage($event,1)">{{ $t('pagination.first') }}</div>
    <div class="pagination-tool  hide-on-pad" :class="{ disabled:listLoading || total<=pageSize || pages==1 }" @click="goPage($event,pages-1)">{{ $t('pagination.prev') }}</div>
    <el-pagination
      :page-size="pageSize"
      :pager-count="5"
      layout="pager"
      :current-page="pages"
      :total="total"
      class="custom-pagination"
      :disabled="listLoading"
      @current-change="handelPaginationChange"
    >
    </el-pagination>
    <div class="pagination-tool  hide-on-pad" :class="{ disabled:listLoading || total<=pageSize || pages==Math.ceil(total/pageSize) }" @click="goPage($event,pages+1)">{{ $t('pagination.next') }}</div>
    <div class="pagination-tool ml-20  hide-on-pad" :class="{ disabled:listLoading || total<=pageSize || pages==Math.ceil(total/pageSize) }" @click="goPage($event,Math.ceil(total/pageSize))">{{ $t('pagination.last') }}</div>
  </div>
</template>

<script>
  export default {
    name: 'pagination',
    props: ['pageSize','pages','total','listLoading'],
    created() {

    },
    methods: {
      handelPaginationChange(index) {
        this.goPage('',index);
      },
      goPage(e,index) {
        // 正在抓取资料
        if(this.listLoading) return;
        // 订单的总数小于一页显示
        if(this.total<=this.pageSize) return;
        // 如果disable了就不继续往下了
        if(e && e.target.classList.contains('disabled')) return;
        // 下面两行应该是不用了，先保留
        if(index<1) index = 1;
        if(index>Math.ceil(this.total/this.pageSize)) index = Math.ceil(this.total/this.pageSize);
        // this.pages = index;
        // this.getList({index});
        this.$emit('handelPaginationChange',index)
      }
    }
  }
</script>

<style lang="less" scoped>
.pagination-block {
    padding: 30px 0;
    display: flex;
    justify-content: center;
    .pagination-tool {
      line-height: 28px;
      cursor: pointer;
      font-weight: 500;
      color: #707070;
      &.disabled {
        color: #C0C4CC;
        cursor: not-allowed;
      }
    }
    /deep/ .custom-pagination {
      display: flex;
      justify-content: center;
      li {
        border-radius: 50%;
        min-width: unset;
        width: 28px;
        margin-right: 20px;
        &:nth-child(1) {
          margin-left: 20px;
        }
      }
      li.active,li:hover {
        background: #ec4f00;
        color: white;
      }
    }
  }
</style>